import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import TargetIcon from 'mdi-react/TargetIcon';
import { FaAustralSign } from 'react-icons/fa6';
import { Field, Form } from 'react-final-form';
import PropTypes from 'prop-types';
import { FormContainer, FormGroup, FormButtonToolbar } from '@/shared/components/form/FormElements';
import { colorGreen, colorWhite } from '@/utils/palette';
import { left, right } from '@/utils/directions';
import TextEditor from '@/shared/components/text-editor/TextEditor';
import { Button, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { TbMessage2Cog } from 'react-icons/tb';
import { AuthContext } from '../../../../../context/AuthContext';
import Welcome from './Welcome';

const renderTextEditor = ({ input }) => <TextEditor {...input} />;

renderTextEditor.propTypes = {
  input: PropTypes.shape({}).isRequired,
};

const WelcomeMessage = () => {
  const [showtcmodal, settcmodal] = useState(false);
  const { apiGlobal } = useContext(AuthContext);
  const [tcData, settcData] = useState('');

  const fetchtermsAndConditions = async () => {
    try {
      const url = await fetch(`${apiGlobal}/terms_condition_data.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // body: JSON.stringify({
        //   id: 1,
        // }),
      });
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        console.log(data);
        settcData(data.data[0]?.terms || 'hello');
        // console.log(data.data[0]?.terms);
      } else {
        settcData('');
      }
    } catch (error) {
      console.error('Error fetching terms and conditions:', error);
    }
  };
  useEffect(() => {
    fetchtermsAndConditions();
  }, []);


  // const handleSubmitTC = async (values) => {
  //   if (!values.text) {
  //     toast.error('Please fill in the text field.');
  //     return;
  //   }

  //   const formdata = new FormData();
  //   formdata.append('id', 1);
  //   formdata.append('terms_condition', values.text);
  //   formdata.append('user_id', 1);

  //   try {
  //       const url = await fetch(`${apiGlobal}terms_condition.php`, {
  //         method: 'POST',
  //         body: formdata,
  //       });
  //       const response = await url.json();
  //       if (response.status) {
  //         toast.success('Terms and Condition updated successfully!');
  //         settcmodal(false);
  //       } else {
  //           toast.error('Failed to update Terms and Condition!');
  //       }
  //   } catch (error) {
  //       console.log(error);
  //   }
  // };

  return (
    <div>
      <DashboardBookingMission>
        <TbMessage2Cog />
        <DashboardBookingMissionTitle>Welcome Notification(WIP)</DashboardBookingMissionTitle>
        <DashboardBookingMissionDescription>
          <Button variant="link" onClick={() => settcmodal(true)}>
            Click here
          </Button>
          to change Welcome Message.
        </DashboardBookingMissionDescription>
      </DashboardBookingMission>

      <Modal show={showtcmodal} onHide={() => settcmodal(false)} centered size="md" backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Welcome Message Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Welcome />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WelcomeMessage;

// region STYLES
const DashboardBookingMission = styled.div`
  text-align: ${left};
  height: 108px;
  background: skyblue;
  border-radius: 5px;
  padding: 15px 13px;
  position: relative;
  overflow: hidden;

  svg {
    position: absolute;
    height: 80px;
    width: 80px;
    top: calc(50% - 40px);
    opacity: 0.3;
    ${right}: -23px;
    color: ${colorWhite};
  }
`;

const DashboardBookingMissionDescription = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.25;
  color: ${colorWhite};
  max-width: 100%;

  @media screen and (min-width: 376px) and (max-width: 991px) {
    max-width: calc(100% - 60px);
  }

  @media screen and (min-width: 1200px) and (max-width: 1550px) {
    font-size: 14px;
  }

  @media screen and (max-width: 420px) {
    font-size: 14px;
  }
`;

const DashboardBookingMissionTitle = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: ${colorWhite};
  margin-top: 0;
  margin-bottom: 4px;
  line-height: 1.25;

  @media screen and (min-width: 1200px) and (max-width: 1399px) {
    font-size: 20px;
  }
`;
// endregion
